import { HTMLAttributes, useState } from 'react';
import { DrawerContext } from '../context';

interface ComponentProps extends HTMLAttributes<HTMLElement> {}

export function DrawerProvider({ children }: ComponentProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <DrawerContext.Provider
      value={{
        isOpen,
        setIsOpen,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
}
